import React, { useContext, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import {
  Container,
  Form,
  Label,
  Modal,
} from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import TextInput from "../../../app/common/form/TextInput";
import { getTestSetStatusOptions } from "../../../app/util/GeneralEnumsOptions";
import { TestSetStatusEnum } from "../../../app/util/GeneralEnums";
import ActionHistory from "../../trackingDocument/invoice/ActionHistory";

const Step2 = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const {
    testSetStatus,
    modalActionHistory,
    openModal,
    closeModal,
  } = rootStore.companyStore;
  const [testDianForm] = useState({
    testSetId:
      testSetStatus.testSetStatus > TestSetStatusEnum.WaitForFirstDocument
        ? testSetStatus.firstInvoiceName
        : "",
  });

  return (
    <div>
      <FinalForm
        initialValues={testDianForm}
        onSubmit={() => {}}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Container textAlign="justified">
              <label>
                Enviá una factura desde tu herrramienta de facturación
              </label>
              <Field name="testSetId" readOnly={true} component={TextInput} />
              {testSetStatus?.testSetStatus !== TestSetStatusEnum.Sucess && (
                <Label
                  basic
                  color={
                    testSetStatus?.testSetStatus ===
                      TestSetStatusEnum.OneOrMoreDocsNoConfirmed ||
                    testSetStatus?.testSetStatus ===
                      TestSetStatusEnum.FirstDocumentRejected
                      ? "red"
                      : "green"
                  }
                >
                  {getTestSetStatusOptions(testSetStatus?.testSetStatus)}
                </Label>
              )}
              {testSetStatus.testSetStatus ===
                TestSetStatusEnum.FirstDocumentRejected && (
                <div>
                  <br/>
                  <a href="#he" onClick={openModal}>
                    Detalle de errores
                  </a>
                  <Modal
                    size="fullscreen"
                    open={modalActionHistory}
                    centered={false}
                    onClose={closeModal}
                    closeIcon
                  >
                    <Modal.Header>Historial de acciones</Modal.Header>
                    <Modal.Content> <ActionHistory id={testSetStatus.firstInvoiceID} /></Modal.Content>
                  </Modal>
                  
                </div>
              )}
            </Container>
          </Form>
        )}
      />
    </div>
  );
};

export default observer(Step2);
